import React from 'react'
import ItemsTable from '../cells/ItemsTable';
import './ItemsPro.css'

const ItemsPro = () => {
  return (
    <div className='itemsProCanvas'>    
      <div className='itemsPro'>
          <ItemsTable />          
      </div>
    </div>
  )
}

export default React.memo(ItemsPro);